import { ContextMenu } from './useContextMenu';
import { useCallback, useState } from 'react';
import { Menu, MenuItem } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import {
  LoadingIndicator,
  ConfirmationDialog,
} from '@xolv-mybrightlink/common';

export const DeleteMessageMenu = (props: {
  contextMenu: ContextMenu;
  closeContextMenu: () => void;
  onDelete: () => Promise<void>;
}) => {
  const { contextMenu, closeContextMenu, onDelete } = props;
  const [loading, setLoading] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);

  const openConfirmationDialog = useCallback(() => {
    closeContextMenu();
    setOpenDialog(true);
  }, [closeContextMenu]);

  const cancelDialogAction = useCallback(() => {
    setOpenDialog(false);
  }, []);

  const deleteMessage = useCallback(async () => {
    setOpenDialog(false);
    setLoading(true);
    try {
      await onDelete();
    } catch (e) {
      console.debug('Cannot delete message', e);
    } finally {
      setLoading(false);
    }
  }, [onDelete]);

  if (loading) {
    return <LoadingIndicator fullHeight overlay sx={{ position: 'fixed' }} />;
  }

  return (
    <>
      <Menu
        open={!!contextMenu}
        onClose={closeContextMenu}
        anchorReference='anchorPosition'
        anchorPosition={
          contextMenu
            ? { top: contextMenu.mouseY, left: contextMenu.mouseX }
            : undefined
        }
        sx={{
          '& .MuiPaper-root': { bgcolor: 'transparent', boxShadow: 'none' },
        }}
      >
        <MenuItem
          onClick={openConfirmationDialog}
          sx={{
            borderRadius: 3,
            bgcolor: 'secondary.main',
            color: 'secondary.contrastText',
            fontWeight: 500,
            px: 14,
            py: 2.5,
            '&.Mui-focusVisible': {
              bgcolor: 'secondary.main',
              color: 'secondary.contrastText',
            },
            '&:hover': {
              bgcolor: 'secondary.main',
              color: 'secondary.contrastText',
            },
          }}
        >
          <FormattedMessage id='action.delete' />
        </MenuItem>
      </Menu>
      <ConfirmationDialog
        open={openDialog}
        titleId='message.delete.title'
        contentId='message.delete.content'
        primaryActionTitleId='message.delete.confirm'
        primaryAction={deleteMessage}
        secondaryActionTitleId='common.cancel'
        secondaryAction={cancelDialogAction}
      />
    </>
  );
};
